import { useState, useEffect, useCallback } from 'react';
import { userService } from '../services/api';

export function useUsers({ enabled = true } = {}) {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(enabled);
    const [error, setError] = useState(null);

    const fetchUsers = useCallback(async () => {
        try {
            const data = await userService.getAll();
            setUsers(data);
            setError(null);
        } catch (err) {
            console.error('Error fetching users:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (enabled) {
            fetchUsers();
        } else {
            setLoading(false);
        }

        const handleUpdate = () => {
            if (enabled) fetchUsers();
        };

        window.addEventListener('users_updated', handleUpdate);
        return () => window.removeEventListener('users_updated', handleUpdate);
    }, [enabled, fetchUsers]);

    return { users, loading, error, refetchUsers: fetchUsers };
}
